import Backbone from "backbone";
import _ from "lodash";

import { QUESTION_TYPE } from "lib/constants";

import Base from "./base";

const CHOICE_TYPES = [
    QUESTION_TYPE.CHOOSE_ONE,
    QUESTION_TYPE.SELECT_ONE,
    QUESTION_TYPE.FOLLOW_UP,
    QUESTION_TYPE.RATE_ONE,
    QUESTION_TYPE.RATE_SATISFACTION,
];

const Question = Base.Model.extend({
    defaults: {
        id: null,
        company_name: null,
        question: "",
        follow_up: "",
        follow_up_response: null,
        reprompt_threshold: null,
        reprompt_answers: null,
        answer: null,
        type: null,
        response: null,
        keywords: [],
        months: 0,
        has_skill: false,
    },
    toJSON() {
        const data = Backbone.Model.prototype.toJSON.call(this);
        data.clean = this.isClean();
        return data;
    },
    initialize() {
        if (this.isSkill() && this.get("response")) {
            this.setSkill(this.get("response"));
        }
    },
    isSkill() {
        return this.get("type") == QUESTION_TYPE.SELECT_ONE;
    },
    hasSkill() {
        return this.isSkill() && this.get("has_skill");
    },
    shouldReprompt() {
        let threshold = this.get("reprompt_threshold");
        if (!threshold) {
            return false;
        }

        threshold = new Date(threshold);
        if (threshold > new Date()) {
            return false;
        }

        const reprompt = this.get("reprompt_answers");
        const response = this.get("response");

        if (!reprompt || !_.includes(reprompt, response)) {
            return false;
        }

        return true;
    },
    isClean() {
        const response = this.get("response");

        if (!response || (Array.isArray(response) && response.length === 0)) {
            return false;
        }

        const followUp = this.getFollowUpAnswer();
        if (followUp && response == followUp && !this.get("follow_up_response")) {
            return false;
        }

        return true;
    },
    getKeywords() {
        if (!this.hasSkill()) {
            return [];
        }

        return this.get("keywords") || [];
    },
    getMonths() {
        if (!this.hasSkill()) {
            return 0;
        }

        return this.get("months") || 0;
    },
    getAnswerFromResponse() {
        return this.getAnswerFromId(this.get("response"));
    },
    getFollowUpAnswer() {
        const answer = _.filter(this.get("answer"), (a) => a.has_follow_up);
        return answer.length ? answer[0].id : null;
    },
    getAnswerFromId(id) {
        const answer = _.filter(this.get("answer"), (a) => a.id == id);
        return answer.length ? answer[0] : null;
    },
    setSkill(id) {
        if (id !== "a1") {
            // For isSkill scenarios, a1 is No Experience
            this.set("has_skill", true);
            const answer = this.getAnswerFromId(id);
            if (answer && answer.months) {
                this.set("months", answer.months);
            }
        }
    },
    set(attributes, options) {
        if (attributes == "response") {
            this.setSkill(options);
        }
        return Backbone.Model.prototype.set.call(this, attributes, options);
    },
});

const Questions = Backbone.Collection.extend({
    model: Question,
});

export default {
    Question,
    Questions,
    TYPE: QUESTION_TYPE,
    CHOICE_TYPES,
};
